/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: ub5TK1CVdqAT

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFooterTopDownload.module.css"; // plasmic-import: ub5TK1CVdqAT/css

createPlasmicElementProxy;

export type PlasmicFooterTopDownload__VariantMembers = {};
export type PlasmicFooterTopDownload__VariantsArgs = {};
type VariantPropType = keyof PlasmicFooterTopDownload__VariantsArgs;
export const PlasmicFooterTopDownload__VariantProps =
  new Array<VariantPropType>();

export type PlasmicFooterTopDownload__ArgsType = {};
type ArgPropType = keyof PlasmicFooterTopDownload__ArgsType;
export const PlasmicFooterTopDownload__ArgProps = new Array<ArgPropType>();

export type PlasmicFooterTopDownload__OverridesType = {
  footerTopDownload?: Flex__<"div">;
  desktop?: Flex__<"div">;
  download?: Flex__<"h6">;
  row2?: Flex__<"div">;
  play?: Flex__<"div">;
  play2?: Flex__<"a"> & Partial<LinkProps>;
  pngegg1?: Flex__<"div">;
  qr1?: Flex__<"a"> & Partial<LinkProps>;
  appstore?: Flex__<"div">;
  apple?: Flex__<"a"> & Partial<LinkProps>;
  pngegg2?: Flex__<"div">;
  qr2?: Flex__<"a"> & Partial<LinkProps>;
  mobileTablet?: Flex__<"div">;
  download3?: Flex__<"h6">;
  row6?: Flex__<"div">;
  play6?: Flex__<"a"> & Partial<LinkProps>;
  play7?: Flex__<"div">;
  apple3?: Flex__<"a"> & Partial<LinkProps>;
  pngegg5?: Flex__<"div">;
};

export interface DefaultFooterTopDownloadProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFooterTopDownload__RenderFunc(props: {
  variants: PlasmicFooterTopDownload__VariantsArgs;
  args: PlasmicFooterTopDownload__ArgsType;
  overrides: PlasmicFooterTopDownload__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"footerTopDownload"}
      data-plasmic-override={overrides.footerTopDownload}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.footerTopDownload
      )}
    >
      <div
        data-plasmic-name={"desktop"}
        data-plasmic-override={overrides.desktop}
        className={classNames(projectcss.all, sty.desktop)}
      >
        <h6
          data-plasmic-name={"download"}
          data-plasmic-override={overrides.download}
          className={classNames(
            projectcss.all,
            projectcss.h6,
            projectcss.__wab_text,
            sty.download
          )}
        >
          {"Download Mobile Application"}
        </h6>
        <div
          data-plasmic-name={"row2"}
          data-plasmic-override={overrides.row2}
          className={classNames(projectcss.all, sty.row2)}
        >
          <div
            data-plasmic-name={"play"}
            data-plasmic-override={overrides.play}
            className={classNames(projectcss.all, sty.play)}
          >
            <PlasmicLink__
              data-plasmic-name={"play2"}
              data-plasmic-override={overrides.play2}
              aria-label={"Download MyEvaluations mobile app for Android"}
              className={classNames(projectcss.all, projectcss.a, sty.play2)}
              component={Link}
              href={
                "https://play.google.com/store/apps/details?id=mobile.myevals"
              }
              legacyBehavior={false}
              platform={"nextjs"}
              target={"_blank"}
              title={"Download MyEvaluations mobile app for Android"}
            >
              <div
                data-plasmic-name={"pngegg1"}
                data-plasmic-override={overrides.pngegg1}
                className={classNames(projectcss.all, sty.pngegg1)}
              />
            </PlasmicLink__>
            <PlasmicLink__
              data-plasmic-name={"qr1"}
              data-plasmic-override={overrides.qr1}
              aria-label={"Download MyEvaluations mobile app for Android"}
              className={classNames(projectcss.all, projectcss.a, sty.qr1)}
              component={Link}
              href={
                "https://play.google.com/store/apps/details?id=mobile.myevals"
              }
              legacyBehavior={false}
              platform={"nextjs"}
              target={"_blank"}
              title={"Download MyEvaluations mobile app for Android"}
            />
          </div>
          <div
            data-plasmic-name={"appstore"}
            data-plasmic-override={overrides.appstore}
            className={classNames(projectcss.all, sty.appstore)}
          >
            <PlasmicLink__
              data-plasmic-name={"apple"}
              data-plasmic-override={overrides.apple}
              aria-label={"Download MyEvaluations mobile app for iOS"}
              className={classNames(projectcss.all, projectcss.a, sty.apple)}
              component={Link}
              href={
                "https://apps.apple.com/eg/app/myevals/id429198930?platform=iphone"
              }
              legacyBehavior={false}
              platform={"nextjs"}
              target={"_blank"}
              title={"Download MyEvaluations mobile app for iOS"}
            >
              <div
                data-plasmic-name={"pngegg2"}
                data-plasmic-override={overrides.pngegg2}
                className={classNames(projectcss.all, sty.pngegg2)}
              />
            </PlasmicLink__>
            <PlasmicLink__
              data-plasmic-name={"qr2"}
              data-plasmic-override={overrides.qr2}
              aria-label={"Download MyEvaluations mobile app for iOS"}
              className={classNames(projectcss.all, projectcss.a, sty.qr2)}
              component={Link}
              href={
                "https://apps.apple.com/eg/app/myevals/id429198930?platform=iphone"
              }
              legacyBehavior={false}
              platform={"nextjs"}
              target={"_blank"}
              title={"Download MyEvaluations mobile app for iOS"}
            />
          </div>
        </div>
      </div>
      <div
        data-plasmic-name={"mobileTablet"}
        data-plasmic-override={overrides.mobileTablet}
        className={classNames(projectcss.all, sty.mobileTablet)}
      >
        <h6
          data-plasmic-name={"download3"}
          data-plasmic-override={overrides.download3}
          className={classNames(
            projectcss.all,
            projectcss.h6,
            projectcss.__wab_text,
            sty.download3
          )}
        >
          {"Download Mobile Application"}
        </h6>
        <div
          data-plasmic-name={"row6"}
          data-plasmic-override={overrides.row6}
          className={classNames(projectcss.all, sty.row6)}
        >
          <PlasmicLink__
            data-plasmic-name={"play6"}
            data-plasmic-override={overrides.play6}
            aria-label={"Download MyEvaluations mobile app for Android"}
            className={classNames(projectcss.all, projectcss.a, sty.play6)}
            component={Link}
            href={
              "https://play.google.com/store/apps/details?id=mobile.myevals"
            }
            legacyBehavior={false}
            platform={"nextjs"}
            target={"_blank"}
            title={"Download MyEvaluations mobile app for Android"}
          >
            <div
              data-plasmic-name={"play7"}
              data-plasmic-override={overrides.play7}
              className={classNames(projectcss.all, sty.play7)}
            />
          </PlasmicLink__>
          <PlasmicLink__
            data-plasmic-name={"apple3"}
            data-plasmic-override={overrides.apple3}
            aria-label={"Download MyEvaluations mobile app for iOS"}
            className={classNames(projectcss.all, projectcss.a, sty.apple3)}
            component={Link}
            href={
              "https://apps.apple.com/eg/app/myevals/id429198930?platform=iphone"
            }
            legacyBehavior={false}
            platform={"nextjs"}
            target={"_blank"}
            title={"Download MyEvaluations mobile app for iOS"}
          >
            <div
              data-plasmic-name={"pngegg5"}
              data-plasmic-override={overrides.pngegg5}
              className={classNames(projectcss.all, sty.pngegg5)}
            />
          </PlasmicLink__>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  footerTopDownload: [
    "footerTopDownload",
    "desktop",
    "download",
    "row2",
    "play",
    "play2",
    "pngegg1",
    "qr1",
    "appstore",
    "apple",
    "pngegg2",
    "qr2",
    "mobileTablet",
    "download3",
    "row6",
    "play6",
    "play7",
    "apple3",
    "pngegg5"
  ],
  desktop: [
    "desktop",
    "download",
    "row2",
    "play",
    "play2",
    "pngegg1",
    "qr1",
    "appstore",
    "apple",
    "pngegg2",
    "qr2"
  ],
  download: ["download"],
  row2: [
    "row2",
    "play",
    "play2",
    "pngegg1",
    "qr1",
    "appstore",
    "apple",
    "pngegg2",
    "qr2"
  ],
  play: ["play", "play2", "pngegg1", "qr1"],
  play2: ["play2", "pngegg1"],
  pngegg1: ["pngegg1"],
  qr1: ["qr1"],
  appstore: ["appstore", "apple", "pngegg2", "qr2"],
  apple: ["apple", "pngegg2"],
  pngegg2: ["pngegg2"],
  qr2: ["qr2"],
  mobileTablet: [
    "mobileTablet",
    "download3",
    "row6",
    "play6",
    "play7",
    "apple3",
    "pngegg5"
  ],
  download3: ["download3"],
  row6: ["row6", "play6", "play7", "apple3", "pngegg5"],
  play6: ["play6", "play7"],
  play7: ["play7"],
  apple3: ["apple3", "pngegg5"],
  pngegg5: ["pngegg5"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  footerTopDownload: "div";
  desktop: "div";
  download: "h6";
  row2: "div";
  play: "div";
  play2: "a";
  pngegg1: "div";
  qr1: "a";
  appstore: "div";
  apple: "a";
  pngegg2: "div";
  qr2: "a";
  mobileTablet: "div";
  download3: "h6";
  row6: "div";
  play6: "a";
  play7: "div";
  apple3: "a";
  pngegg5: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFooterTopDownload__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFooterTopDownload__VariantsArgs;
    args?: PlasmicFooterTopDownload__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFooterTopDownload__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFooterTopDownload__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFooterTopDownload__ArgProps,
          internalVariantPropNames: PlasmicFooterTopDownload__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFooterTopDownload__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footerTopDownload") {
    func.displayName = "PlasmicFooterTopDownload";
  } else {
    func.displayName = `PlasmicFooterTopDownload.${nodeName}`;
  }
  return func;
}

export const PlasmicFooterTopDownload = Object.assign(
  // Top-level PlasmicFooterTopDownload renders the root element
  makeNodeComponent("footerTopDownload"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    download: makeNodeComponent("download"),
    row2: makeNodeComponent("row2"),
    play: makeNodeComponent("play"),
    play2: makeNodeComponent("play2"),
    pngegg1: makeNodeComponent("pngegg1"),
    qr1: makeNodeComponent("qr1"),
    appstore: makeNodeComponent("appstore"),
    apple: makeNodeComponent("apple"),
    pngegg2: makeNodeComponent("pngegg2"),
    qr2: makeNodeComponent("qr2"),
    mobileTablet: makeNodeComponent("mobileTablet"),
    download3: makeNodeComponent("download3"),
    row6: makeNodeComponent("row6"),
    play6: makeNodeComponent("play6"),
    play7: makeNodeComponent("play7"),
    apple3: makeNodeComponent("apple3"),
    pngegg5: makeNodeComponent("pngegg5"),

    // Metadata about props expected for PlasmicFooterTopDownload
    internalVariantProps: PlasmicFooterTopDownload__VariantProps,
    internalArgProps: PlasmicFooterTopDownload__ArgProps
  }
);

export default PlasmicFooterTopDownload;
/* prettier-ignore-end */
